import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlankPage } from '@/database/userPageDatabaseService';
import { formatDateToString } from '@/utility/utils';

interface BlankPageState {
  currentBlankPage: BlankPage;
  blankPages: BlankPage[];
}

// ** Slice
const initialState: BlankPageState = {
  currentBlankPage: {
    id: null,
    userId: '',
    json: '',
    bookId: 0,
    title: '',
    paperType: '',
    dataUrl: '',
    createdDate: formatDateToString(new Date()),
  },
  blankPages: [],
};

export const whiteBoardSlice = createSlice({
  name: 'whiteBoardSlice',
  initialState,
  reducers: {
    setCurrentBlankPage: (state, action: PayloadAction<BlankPage>) => {
      if(action.payload !== null){
        state.currentBlankPage = action.payload;
        const blankPages = state.blankPages.map((item) => {
          const temp = Object.assign({}, item);
          if (action.payload.id === item.id) {
            temp.json = action.payload.json;
            temp.paperType = action.payload.paperType;
          }
          return temp;
        });
        state.blankPages = blankPages;
      }
    },
    setBlankPages : (state, action: PayloadAction<BlankPage[]>) => {
      state.blankPages = action.payload;
    }
  },
});

export const { setCurrentBlankPage, setBlankPages} = whiteBoardSlice.actions;

export default whiteBoardSlice.reducer;
